import React from 'react';
import { motion } from 'framer-motion';

export default function PageHero({ title, subtitle, scriptText, bgImage, bgPosition = 'center', overlayOpacity = 0.65, children }) {
  return (
    <section className="page-hero" style={{
      position: 'relative',
      minHeight: '400px',
      height: 'auto',
      aspectRatio: '16 / 7',
      overflow: 'hidden',
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: bgPosition,
    }}>
      <div style={{ position: 'absolute', inset: 0, background: `rgba(26,46,26,${overlayOpacity})` }} />
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 120, background: 'linear-gradient(to top, var(--white), transparent)' }} />
      <div className="page-hero-content" style={{
        position: 'relative', zIndex: 1, height: '100%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexDirection: 'column', textAlign: 'center', padding: '20px',
        paddingTop: 'clamp(80px, 15vw, 120px)',
      }}>
        {scriptText && (
          <motion.span
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
            style={{ fontFamily: 'Pinyon Script, cursive', fontSize: '2.2rem', color: 'var(--gold-light)', display: 'block', marginBottom: 8 }}
          >{scriptText}</motion.span>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.15 }}
          style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 'clamp(2.8rem, 5vw, 4.5rem)', color: 'var(--white)', fontWeight: 300, marginBottom: 16 }}
        >{title}</motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.3 }}
            style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '1.15rem', fontStyle: 'italic', color: 'rgba(245,240,232,0.8)', maxWidth: 520 }}
          >{subtitle}</motion.p>
        )}
        {children}
      </div>
    </section>
  );
}
